/* **************************************************** Kitchen range */
export interface FSKitchenStyle {
    id: number;
    style_name: string;
    created_by: number | null;
    status: 1 | 0;
}

export const mapFSKitchenStyle = (data: any): FSKitchenStyle => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: FSKitchenStyle = {
        id: data.id,
        style_name: data.style_name,
        created_by: data.created_by || null,
        status: data.status
    };

    return res;
};

export const mapFSKitchenStyles = (data: any[]): FSKitchenStyle[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapFSKitchenStyle);
};